export interface WrapperLabels {
  collapse: string
  expand: string
  errorFallbackTitle: string
}

export const DEFAULT_WRAPPER_LABELS: WrapperLabels = {
  collapse: 'Collapse',
  expand: 'Expand',
  errorFallbackTitle: 'Widget failed to render',
}
